import { FaClock, FaEnvelope, FaMapMarkedAlt, FaPhoneAlt } from "react-icons/fa";

const contacts = [
    {
        id: 1,
        icon: <FaMapMarkedAlt />,
        title: "address",
        content: ["2667 Powder Springs Rd SW", "Ste 105", "Marietta, GA 30064"],
    },
    {
        id: 2,
        icon: <FaPhoneAlt />,
        title: "call us",
        content: ["(678) 927-8428"],
    },
    {
        id: 3,
        icon: <FaEnvelope />,
        title: "mail us",
        content: ["the23coffeeshop@yahoo.com","info@23coffeeshop.com"],
    },
    {
        id: 4,
        icon: <FaClock />,
        title: 'opening hours',
        content: ["Mon - Fri: 7 AM - 6 PM", "Sat: 7 AM - 6 PM"],
    },
];

export default contacts;
